<label class="file-upload__wrapper-lbl">
    <input #inputTypeFile type="file" style="display: none">
    <div class="file-upload__container"
         [class.file-upload__container--dragover]="isSomethingDraggingOver"
         [class.file-upload__container--file-selected]="isFileSelected"
         [class.file-upload__container--error]="errorMessage">
        <div>
            <i class="vhvicon vhvicon-upload file-upload__upload-icn"></i>
        </div>
        <div class="file-upload__label">
            @if (errorMessage) {
                <div class="file-upload__error-msg">Fehler</div>
                <div class="file-upload__error-description">{{ errorMessage }}</div>
            } @else {
                {{ textLabel }}
                @if (fileSizeInBytes) {
                    ({{ fileSizeInBytes | bytes2HumanReadable }})
                }
            }
        </div>
        <div class="file-upload__unset-file-btn-wrapper">
            @if (isFileSelected) {
                <button
                    type="button"
                    class="file-upload__unset-file-btn"
                    title="Datei entfernen"
                    (click)="onUnsetFileBtnClick($event)">
                    <i class="vhvicon vhvicon-close-big file-upload__unset-file-icn"></i>
                </button>
            }
        </div>
    </div>
</label>
